import { getAddress } from '@ethersproject/address';
export const toChecksumAddress = address => getAddress(address);
//# sourceMappingURL=toChecksumAddress.js.map